export default {
  data() {
    return {
    }
  },
  computed: {
    parametrs() {
      if (!this.item?.parameters) {
        return null
      }
      try {
        return JSON.parse(this.item.parameters)
      } catch {
        return null
      }
    },
    historyItemTitle() {
      if (!this.item) { return null }
      return this.$t(`Tenders.eventType.${this.item.eventType}`)
    },
  },
  props: {
    item: {
      type: Object
    },
    dataQa: {
      type: String,
    },
    spr: {
      type: Object
    },
  },
}
